
<app-enum-i18n [input]="options" (output)="setOptionsI18n($event)"></app-enum-i18n>
<div #mermaid class="diagram-center"></div>
